import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useValeContext } from '../context/Vale.context';

const VerMasVales = ({ handleVerMasClick, id }) => {
  const { t } = useTranslation();
  const {
    changeShowMoreNoAct,
    changeShowMoreAct,
    changeShowMoreCanj,
  } = useValeContext();
  const handleClickTheShowMore = (e) => {
    if (id === 1) {
      changeShowMoreNoAct(true);
    } else if (id === 2) {
      changeShowMoreAct(true);
    } else if (id === 3) {
      changeShowMoreCanj(true);
    }
    handleVerMasClick(e);
  };

  return (
    <p className="u-text-center">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        id={`${id}`}
        to="#"
        onClick={handleClickTheShowMore}
        className="link__mas"
      >
        {t('vales.verMas')}
      </Link>
    </p>
  );
};

export default VerMasVales;
